import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/lexicalPluginToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/slateToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/src/components/Media/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/app/src/components/Media/Video/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Price"] */ "/app/src/components/Price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductBanner","VariantBanner","BulkDiscountBanner","DiscountRibbon"] */ "/app/src/components/product/ProductBanners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShopPagination"] */ "/app/src/components/shop/ShopPagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/glass/glass.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistButton"] */ "/app/src/components/WishlistButton/index.tsx");
